export const getTheme = () => {
    const theme = localStorage.getItem('tsm_theme');
    return theme ? theme : 'light';
}

export const saveTheme = ( theme ) => {
    localStorage.setItem('tsm_theme', theme);
}

export const getShortView = () => {
    return localStorage.getItem('tsm_short_view');
}

export const getProjectAreaView = () => {
    return localStorage.getItem('tsm_project_area');
}

export const saveAreaProject = ( type ) => {
    localStorage.setItem('tsm_project_area', type);
}

export const saveShortView  = ( isShort ) => {
    localStorage.setItem('tsm_short_view', isShort ? 'short' : 'full');
}

export const filterAKB = (akb, filter) => {
    return akb.filter((item) => 
        (!filter.hasOwnProperty('station_name') || item?.station_name?.toUpperCase().indexOf(filter.station_name.toUpperCase()) > -1) 
        && 
        (!filter.hasOwnProperty('district') || item?.district?.toUpperCase().indexOf(filter.district.toUpperCase()) === 0)                    
        &&
        (!filter.hasOwnProperty('maintained') || item?.maintained)
    );

}